// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 계좌 관리 화면 - 공통 스타일은 PageLayout.css 참조 */

/* 좌우 분할 레이아웃 - page-body를 꽉 채움 */
.account-body {
  display: flex;
  gap: 16px;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

/* 좌측 그리드 패널 */
.account-list-panel {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 설명 컬럼 - 긴 텍스트 말줄임 */
.col-desc {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #555;
}

/* 우측 폼 패널 */
.account-form-panel {
  width: 280px;
  flex-shrink: 0;
  background: white;
  border: 1px solid #e0e4ef;
  border-radius: 6px;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  overflow-y: auto;
}

.form-title {
  font-size: 12px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.form-group label {
  font-size: 12px;
  font-weight: 600;
  color: #444;
}

.required { color: #e74c3c; }

.form-group input[type="text"],
.form-group input[type="number"],
.form-group textarea {
  padding: 6px 9px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  transition: border-color 0.2s;
  resize: vertical;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #4a90e2;
}

.form-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/reference/AccountPage.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,YAAY,cAAc,EAAE;;AAE5B;;;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB","sourcesContent":["/* 계좌 관리 화면 - 공통 스타일은 PageLayout.css 참조 */\n\n/* 좌우 분할 레이아웃 - page-body를 꽉 채움 */\n.account-body {\n  display: flex;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* 좌측 그리드 패널 */\n.account-list-panel {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* 설명 컬럼 - 긴 텍스트 말줄임 */\n.col-desc {\n  max-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #555;\n}\n\n/* 우측 폼 패널 */\n.account-form-panel {\n  width: 280px;\n  flex-shrink: 0;\n  background: white;\n  border: 1px solid #e0e4ef;\n  border-radius: 6px;\n  padding: 16px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n  overflow-y: auto;\n}\n\n.form-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 16px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 12px;\n}\n\n.form-group label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n}\n\n.required { color: #e74c3c; }\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"number\"],\n.form-group textarea {\n  padding: 6px 9px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  transition: border-color 0.2s;\n  resize: vertical;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.form-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
